import { NgModule } from '@angular/core';
import { FiADIntegrationService } from './ad-integration.service';
import { FiADIntegrationMappingModule } from './group-mapping/group-mapping.module';
import { FiAdIntegrationComponent } from './ad-integration.component';
import { CommonModule } from '@angular/common';
import { FiTabsModule } from '../../utilities/tabs/tabs.module';
import { FiADIntegrationADImportModule } from './ad-import/ad-import.module';
import { FiAppTextSharedModule } from '../../shared/app-text';
import { UIRouterModule } from '@uirouter/angular';
import { FiADIntegrationStates } from './ad-integration-states';

@NgModule({
    imports: [
        CommonModule,
        FiTabsModule,
        FiADIntegrationMappingModule,
        FiADIntegrationADImportModule,
        FiAppTextSharedModule,
        UIRouterModule.forChild(FiADIntegrationStates),
    ],
    providers: [FiADIntegrationService],
    declarations: [FiAdIntegrationComponent],
})
export class FiADIntegrationModule {}
